import React from 'react';
import '@/App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Toaster } from 'sonner';

import { AuthProvider } from './contexts/AuthContext';
import { I18nProvider } from './contexts/I18nContext';
import Header from './components/Header';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
import HomePage from './pages/HomePage';
import ToolPage from './pages/ToolPage';
import DashboardPage from './pages/DashboardPage';
import PricingPage from './pages/PricingPage';
import AdminPage from './pages/AdminPage';
import { LoginPage, RegisterPage } from './pages/AuthPages';
import { AISummarizePage, AITranslatePage, AIExtractPage, AIChatPage } from './pages/AIPages';
import { BlogListPage, BlogPostPage } from './pages/BlogPages';

function App() {
  return (
    <I18nProvider>
      <AuthProvider>
        <BrowserRouter>
          <ScrollToTop />
          <div className="App min-h-screen flex flex-col bg-vault-bg text-white">
            <Header />
            <main className="flex-1">
              <Routes>
                <Route path="/" element={<HomePage />} />
                <Route path="/login" element={<LoginPage />} />
                <Route path="/register" element={<RegisterPage />} />
                <Route path="/dashboard" element={<DashboardPage />} />
                <Route path="/pricing" element={<PricingPage />} />
                <Route path="/admin" element={<AdminPage />} />
                <Route path="/blog" element={<BlogListPage />} />
                <Route path="/blog/:slug" element={<BlogPostPage />} />
                <Route path="/ai-summarize" element={<AISummarizePage />} />
                <Route path="/ai-chat" element={<AIChatPage />} />
                <Route path="/ai-translate" element={<AITranslatePage />} />
                <Route path="/ai-extract" element={<AIExtractPage />} />
                <Route path="/:slug" element={<ToolPage />} />
              </Routes>
            </main>
            <Footer />
          </div>
          <Toaster
            position="bottom-right"
            theme="dark"
            toastOptions={{
              style: { background: '#0A1628', border: '1px solid rgba(245,166,35,0.3)', color: '#fff' },
            }}
          />
        </BrowserRouter>
      </AuthProvider>
    </I18nProvider>
  );
}

export default App;
